import { Stack, Text, Box } from '@ltvco/refresh-lib/theme';
import { usePhoneFormatter } from '@ltvco/refresh-lib/utils';
import { useMemo } from 'react';

import { EmailSummaryData } from '../DataTypes/SummaryTypes';

interface EmailReportRendererProps {
  data: EmailSummaryData;
}

const formatFraudScore = (fraudScore: number | undefined): string => {
  if (fraudScore === undefined || fraudScore === null) {
    return 'N/A';
  }

  let riskLevel: string;
  if (fraudScore >= 90) {
    riskLevel = '🔴 High';
  } else if (fraudScore >= 75) {
    riskLevel = '🟡 Medium';
  } else if (fraudScore >= 50) {
    riskLevel = '🟢 Low';
  } else {
    riskLevel = '🟢 Very Low';
  }

  return `${riskLevel} fraud risk`;
};

export const EmailReportRenderer = ({ data }: EmailReportRendererProps) => {
  const formattedPhoneNumber = usePhoneFormatter(data.owner_phone, true);
  const formattedFraudScore = useMemo(
    () => formatFraudScore(data.fraud_score),
    [data.fraud_score]
  );
  return (
    <Stack spacing={2}>
      {data.email && (
        <Text variant="body1">
          We found 1 record for:{' '}
          <span style={{ fontWeight: 700 }}>{data.email}</span>
        </Text>
      )}
      <Stack spacing={1.5}>
        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Email Info:
          </Text>
          <Text variant="body1">
            <span style={{ fontWeight: 700 }}>Email Type:</span>{' '}
            {data.email_type || 'Personal'}
          </Text>
          <Text variant="body1">
            <span style={{ fontWeight: 700 }}>FraudScan Score:</span>{' '}
            {formattedFraudScore}
          </Text>
        </Box>

        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Owner:
          </Text>
          <Text variant="body1">
            <span style={{ fontWeight: 700 }}>Name:</span>{' '}
            {data.owner_name || 'N/A'}
          </Text>
          <Text variant="body1">
            <span style={{ fontWeight: 700 }}>Phone:</span>{' '}
            {formattedPhoneNumber || 'N/A'}
          </Text>
          <Text variant="body1">
            <span style={{ fontWeight: 700 }}>Address:</span>{' '}
            {data.owner_address || 'N/A'}
          </Text>
        </Box>
      </Stack>
    </Stack>
  );
};
